export default {
  toasts: {
    load_error: 'Impossible de charger les factures.',
    action_error: "L'action a échoué — veuillez réessayer.",
    finalized: 'Facture finalisée.',
    marked_paid: 'Facture marquée comme payée.',
  },
  filters: {
    status: 'Filtrer par statut',
  },
  volume_discount_badge: 'Remise sur volume appliquée ({{licenses}} licences, {{percent}}%)',
  columns: {
    description: 'Facture',
    status: 'Statut',
    total: 'Total',
    paid_at: 'Payé le',
  },
  statuses: {
    pending: 'En attente',
    processing: 'En cours',
    paid: 'Payé',
    failed: 'Échoué',
    refunded: 'Remboursé',
    partially_refunded: 'Partiellement remboursé',
  },
  companies: {
    partner_level: 'Ajustements au niveau du partenaire',
    columns: {
      company: 'Restaurant',
      buckets: 'Postes',
      amount: 'Montant',
    },
  },
  buckets: {
    license_fees: 'Frais de licence',
    service_fees: 'Frais de service',
    processing_fees: 'Frais de traitement',
    delivery_fees: 'Frais de livraison',
    gift_card_fees: 'Frais de carte cadeau',
    adjustments: 'Ajustements',
  },
  entries: {
    count: '{{count}} entrées',
    columns: {
      description: 'Entrée',
      occurred_at: 'Date',
      amount: 'Montant',
    },
  },
  incl_tax: 'dont {{amount}} TVA',
  actions: {
    open_invoice_pdf: 'Télécharger la facture (PDF)',
    open_hosted: 'Ouvrir la facture sur Stripe',
    export_csv: 'Exporter CSV',
    finalize: 'Finaliser sur Stripe',
    mark_paid: 'Marquer comme payé',
  },
  finalize: {
    title: 'Finaliser cette facture sur Stripe ?',
    description:
      "La finalisation lance le recouvrement : avec un moyen de paiement enregistré, le débit s'effectue automatiquement ; sinon le partenaire reçoit la facture hébergée.",
    confirm: 'Finaliser',
  },
  mark_paid: {
    pushed_note:
      'Cette facture est déjà sur Stripe — le brouillon sera supprimé (ou une facture finalisée marquée payée hors bande) afin que Stripe cesse le recouvrement.',
    title: 'Marquer cette facture comme payée ?',
    description:
      'Enregistre un paiement manuel (hors ligne) de {{amount}}. À utiliser pour les virements bancaires collectés hors Stripe.',
    confirm: 'Marquer comme payé',
  },
  settlement_badge: {
    paid: 'Part de revenus versée : {{amount}}',
    other: 'Versement de part de revenus {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Versements de part de revenus',
    retry: 'Réessayer',
    toasts: {
      load_error: 'Impossible de charger les versements.',
      retry_error: 'La nouvelle tentative a échoué — veuillez réessayer.',
      retry_paid: 'Part de revenus versée.',
      retry_attempted: "Nouvelle tentative effectuée — le versement n'est pas encore finalisé, vérifiez son statut.",
    },
    columns: {
      period: 'Période',
      amount: 'Montant',
      status: 'Statut',
      transfer: 'Virement',
      paid_at: 'Payé le',
      payout: 'Paiement',
    },
    payout: {
      direct: '{{amount}}, sans conversion',
      direct_tooltip:
        'Dû {{owed}}, converti à 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} et envoyé tel quel : aucune conversion Stripe, aucuns frais.',
      converted: 'Envoyé {{sent}} → arrivé {{arrived}}',
      expected: 'Envoyé {{sent}} → attendu {{arrived}}',
      fee: 'Frais de conversion Stripe {{amount}}',
      net: 'net {{amount}}',
      pending_details: 'Les frais et le net apparaissent une fois que Stripe règle le virement.',
      tooltip:
        "Dû {{owed}}. Converti à 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, envoyé depuis le solde de la plateforme en {{source_currency}}, puis converti par Stripe à 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. Stripe déduit {{fee_rate}}% à l'arrivée.",
    },
    statuses: {
      pending: 'En attente',
      held: 'En attente',
      processing: 'En cours',
      paid: 'Versé',
      failed: 'Échoué',
      reversed: 'Annulé',
    },
    hold_reasons: {
      kyc_incomplete: "Le partenaire n'a pas encore terminé la vérification de son compte de versement.",
      transfers_inactive: 'Le compte de versement ne peut pas encore recevoir de virements.',
      insufficient_platform_balance: 'Le solde de la plateforme ne peut pas couvrir ce versement pour le moment.',
      manual_hold: 'Bloqué manuellement.',
      missing_fx_rate:
        "Aucun taux de change n'est encore enregistré pour la devise du paiement. Nouvelle tentative automatique.",
      unsupported_payout_currency:
        'Stripe ne peut pas effectuer ce paiement dans la devise du compte de paiement à partir du solde de la plateforme.',
      amount_too_small: 'Le montant dû est inférieur au transfert minimum de Stripe pour cette devise.',
    },
  },
};
